import React from 'react';
import useWindowSize from '../../customHooks/useWindowWidth';
import SwipeableBottomSheet from '../../atoms/SwipeableBottomSheet';
import { DatePickerDesktopWrapper } from './subcomponents';
import Calendar from './Calendar';
const DatePickerSelector = ({ commonModalProps, calendarProps, handleCalendarModalClose }) => {
    const windowWidth = useWindowSize();
    return (React.createElement(React.Fragment, null,
        !windowWidth.isLessThanTablet && (React.createElement(DatePickerDesktopWrapper, Object.assign({ escapeModalHandler: handleCalendarModalClose, outsideClickHandler: handleCalendarModalClose, footerClassName: "simple-modal-styled-footer" }, commonModalProps),
            React.createElement(Calendar, Object.assign({}, calendarProps)))),
        windowWidth.isLessThanTablet && (React.createElement(SwipeableBottomSheet, Object.assign({ closeModal: handleCalendarModalClose }, commonModalProps),
            React.createElement(Calendar, Object.assign({}, calendarProps))))));
};
export default DatePickerSelector;
